/**
 * Autosave service for the designer
 * Automatically saves canvas state to localStorage to prevent data loss on page reload
 */

// Constants for storage keys
const AUTOSAVE_KEY = 'kodiak_designer_autosave';
const AUTOSAVE_TIMESTAMP_KEY = 'kodiak_designer_autosave_timestamp';

/**
 * Save the current canvas state to localStorage
 * @param canvasId - The ID of the canvas to save
 * @param canvasState - The JSON state of the canvas
 */
export const saveCanvasState = (canvasId: string, canvasState: string): void => {
  try {
    // Save the canvas state
    localStorage.setItem(AUTOSAVE_KEY, canvasState);
    
    // Save the timestamp for when the autosave occurred
    localStorage.setItem(AUTOSAVE_TIMESTAMP_KEY, Date.now().toString());
    
    console.log('Design autosaved successfully');
  } catch (error) {
    console.error('Error autosaving design:', error);
  }
};

/**
 * Get the autosaved canvas state from localStorage
 * @returns The saved canvas state if it exists, null otherwise
 */
export const getSavedCanvasState = (): string | null => {
  return localStorage.getItem(AUTOSAVE_KEY);
};

/**
 * Get the timestamp of the last autosave
 * @returns The timestamp as a number, or null if no autosave exists
 */
export const getAutosaveTimestamp = (): number | null => {
  const timestamp = localStorage.getItem(AUTOSAVE_TIMESTAMP_KEY);
  return timestamp ? parseInt(timestamp, 10) : null;
};

/**
 * Check if there is an autosaved canvas state
 * @returns True if there is an autosaved state, false otherwise
 */
export const hasAutosavedState = (): boolean => {
  return !!localStorage.getItem(AUTOSAVE_KEY);
};

/**
 * Clear the autosaved canvas state from localStorage
 */
export const clearAutosavedState = (): void => {
  localStorage.removeItem(AUTOSAVE_KEY);
  localStorage.removeItem(AUTOSAVE_TIMESTAMP_KEY);
}; 